module.exports = __webpack_public_path__ + "img/lg_ring_g_i_null_null@3x.f6b4589f.png";